import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { BASE_URL } from "../../utils/config";
import { GetAllInitiatives, AddInitiativePriority } from "../../redux/constants/apiConstants";
import { ContainerMain } from '../common/commonStyles';
import {Heading, InitiativesWrap, InitiativeCard, CheckMarkCount} from './styles'
import {CloseIconBranding, RecognitionTickIcon} from '../../utils/icons'
import { ImageUrl } from "../../utils/constants";
import SkeletonLoder from "../common/skeletonLoder";
import { ButtonContainer } from '../CreateEvent/style';
import {CommonButton} from './styles'
import { fetchApi } from '../../utils/methods';

const CustomizeDashboard = ({history, companyId}) => {
  const [allInitiatives, setAllInitiatives] = useState([]);
  const [selectedInitiatives, setSelectedInitiatives] = useState([]);
  
  useEffect(()=>{
    fetchAllCompanyInitiatives()
  },[])

  const fetchAllCompanyInitiatives = async() => {
    const AuthToken = localStorage.getItem("AUTH_TOKEN");
    let url =
    BASE_URL + GetAllInitiatives;
    await fetch(url, { method: "GET", headers: { AUTHTOKEN: AuthToken },
      credentials:'include',
      withCredentials: true }).then(
      (res) => {
        res.json().then((data) => {
          setAllInitiatives(data.data[0])
        }).catch((error)=>{
          toast.error(error.message);
        });
      }
    ).catch((error)=>{
      toast.error(error.message);
    });
  }

  const handleAddPriorityInitiative = () => {
    const entity = selectedInitiatives?.map((initiative_id) => ({
      initiative_id,
      company_id: companyId
    }));
    PostAPIInitiative(entity);
  }

  const PostAPIInitiative = async(payload)=>{
    try{
      const res = await fetchApi(AddInitiativePriority, "POST",payload);
      if(res.message){
        toast.error(res.message);
      }else{
        toast.success(res.data[0]);
        history.push({pathname:"/company/health",state:"updateData"})
      }
    }catch(error){
      toast.error(error)
    }
  }

  const handleSelectInitiative = (item) => {
    let newSelectedInitiatives = [...selectedInitiatives];
  
    if (newSelectedInitiatives.includes(item.id)) {
      newSelectedInitiatives = newSelectedInitiatives.filter((selectedId) => selectedId !== item.id);
    } else if (newSelectedInitiatives.length < 3) {
      newSelectedInitiatives.push(item.id);
    } else {
      toast.error("You can select up to 3 initiatives only");
    }
    setSelectedInitiatives(newSelectedInitiatives)
  };

  const chunkArray = (arr, size) => (
    arr.reduce((acc, _, i) => 
      i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc
    , [])
  );
  const initiativeChunks = chunkArray(allInitiatives, 3);
  return (
    allInitiatives?.length===0?<ContainerMain><div className='content-wrap'><SkeletonLoder width={"1248px"} height={"500px"}/></div></ContainerMain>:<> 
      <ContainerMain>
        <div className='content-wrap'>
          <Heading>
            <div className='icon' onClick={()=>history.push("/company/health")}><CloseIconBranding/></div>
            Customize Your Dashboard
          </Heading>
          <InitiativesWrap>
            <div className='title'>
              Select the top 3 health initiatives below to customize your dashboard
            </div>
            <div className='border'/>
            <div className="details">
              {initiativeChunks.map((chunk, chunkIndex) => (
                <React.Fragment key={chunkIndex}>
                  <div className="initiative-row">
                    {chunk.map((initiative) => (
                      <div className="initiative-card" key={initiative.id}>
                        <InitiativeCard background={initiative?.color}>
                          <div className="icon">
                            <img src={`${ImageUrl}/${initiative?.initiative_white_icon}`} alt="initiative" />
                          </div>
                          <div className="initiative-title">{initiative.initiative_name}</div>
                          <div className="count">
                            <CheckMarkCount 
                              active={selectedInitiatives.includes(initiative.id)}
                              onClick={() => handleSelectInitiative(initiative)}
                            >
                              {selectedInitiatives.includes(initiative.id) ? selectedInitiatives.indexOf(initiative.id) + 1 : ""}
                            </CheckMarkCount>
                          </div>
                        </InitiativeCard>
                      </div>
                    ))}
                  </div>
                  {/* Border after every row of 3 cards */}
                  {chunkIndex+1!==initiativeChunks?.length&&<div className="border-card"/>}
                </React.Fragment>
              ))}
            </div>
          </InitiativesWrap>
        </div>
      </ContainerMain>
      <ButtonContainer>
        <div className="wrapper">
          <div className='btn'>
            <CommonButton
              disabled={selectedInitiatives?.length < 3}
              title={("Submit")}
              onClick={selectedInitiatives?.length < 3?null:()=>handleAddPriorityInitiative()}
            >
              Done<div style={{marginLeft:"8px", paddingBottom:"2px"}}>{RecognitionTickIcon(selectedInitiatives?.length < 3?"#989898":"#F8F8F8")}</div>
            </CommonButton>
          </div>
        </div>
      </ButtonContainer>
    </>
  );
};

CustomizeDashboard.propTypes = {
  companyInfo: PropTypes.object.isRequired,
  companyId: PropTypes.number,
  companyBrandingDetails: PropTypes.object,
  yearList: PropTypes.array,
  history:PropTypes.object
};

export default connect(null, null)(CustomizeDashboard);